<template>
  <div>
    <el-container class="careStaffLibrary">
      <el-card class="tabs-card">
        <el-form
          :inline="true"
          ref="formRef"
          :model="tableParams"
          class="demo-form-inline"
        >
          <!-- <el-form-item label="设施类别" prop="">
            <h-selectcode
              type="facilityType"
              v-model="tableParams.syxz"
              placeholder="设施类别"
              :clearable="true"
            ></h-selectcode>
          </el-form-item>
          <el-form-item>
            <h-button type="primary" @click="refreshTable">查询</h-button>
            <h-button @click="resetForm(formRef)">重置</h-button>
          </el-form-item> -->
          <el-row>
            <el-col>
              <h-button plain type="primary" @click="selectButton">
                <el-icon><full-screen /></el-icon>选择
              </h-button>
              <h-button plain type="primary" @click="addButton">
                <el-icon><plus /></el-icon>新建
              </h-button>
              <h-button
                :disabled="tableSelection.length === 0"
                plain
                type="danger"
                @click="delUser"
              >
                <el-icon><delete /></el-icon>删除
              </h-button>
              <!-- <h-button plain type="primary">
                <el-icon><upload /></el-icon>导入
              </h-button>
              <h-button plain type="primary">
                <el-icon><download Upload /></el-icon>导出
              </h-button>
              <h-button plain type="primary" @click="setUpClick">
                <el-icon><upload /></el-icon>导入
                设置
              </h-button> -->
            </el-col>
          </el-row>
        </el-form>
        <div class="table-box">
          <h-table
            ref="tableRef"
            style="height: 500px"
            v-model:data="tableData"
            :columns="form.libraryFlag == '1' ? columns : columnsCar"
            :method="
              form.libraryFlag == '1' ? basepeoplegetprison : baseCargetList
            "
            :params="form.libraryFlag == '1' ? tableParams : tableCarParams"
            @handleClick="handleClick"
            @select="hzTableSelect"
          >
            <template #name="{ row }">
              <u @click="nameCLickDialog(row)" class="table-row-name">{{
                row.personName
              }}</u>
            </template>

            <template #imageUrl="{ row }">
              <span v-if="!row.fileUrl">{{ "暂无" }}</span>

              <img v-else :src="imgURL + row.fileUrl" />
            </template>
            <template v-if="form.libraryFlag !== '1'" #carNumber="{ row }">
              <!-- <h-car-plate class="plateNo" :type="row.carCardColor">
                {{
                  row.carNumber == ""
                    ? "暂无车牌"
                    : row.carProvinceDict + row.carNumber
                }}
              </h-car-plate> -->
              {{ row.carNumber == "" ? "暂无车牌" : row.carNumber }}
            </template>
          </h-table>
        </div>
      </el-card>
    </el-container>
    <el-dialog
      v-model="formVisible"
      :title="
        (form.libraryFlag == 1 ? '人员' : '车辆') +
        (status === 1 ? '新增' : status === 2 ? '编辑' : '详情')
      "
      width="33%"
    >
      <nameChildrenAdd
        v-if="formVisible"
        v-model="formVisible"
        :form="userFormData"
        :formfather="form"
        :status="status"
        @submit="refreshTable"
      ></nameChildrenAdd>
    </el-dialog>
    <el-dialog
      v-model="formVisibleobject"
      top="20vh"
      title="选择对象"
      width="70%"
    >
      <select-object
        v-model:dataFlag="form"
        @tableSelectionObj="tableSelectionObj"
        @tableRefresh="refreshTable"
        @cancel="cancel"
      ></select-object>
    </el-dialog>
    <el-dialog v-model="setupVisible" title="设置" width="33%">
      <setupDialog
        v-model="setupVisible"
        :status="status"
        :formfather="form"
        @submit="refreshTable"
      ></setupDialog>
    </el-dialog>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  watchEffect,
  watch,
} from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import {
  FullScreen,
  Plus,
  Delete,
  Download,
  Upload,
} from "@element-plus/icons-vue";
import selectObject from "./selectObject.vue";
import nameChildrenAdd from "./nameChildrenAdd.vue";
import setupDialog from "./setupDialog.vue";

import {
  basepeoplegetprison,
  saveByPrison,
  baseprisondelete,
  baseCargetList,
  baseCarDetele,
} from "@/api/communityCare/communityCareApi.js";
import {
  dispositionFace,
  dispositionCar,
} from "@/api/monitorManagement/monitorManagementApi.js";
import { url2ToBase } from "@/api/smartApplication/personSearchApi.js";
export default defineComponent({
  components: {
    FullScreen,
    Plus,
    Delete,
    Download,
    Upload,
    selectObject,
    nameChildrenAdd,
    setupDialog,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const formRef = ref(null);
    const tableRef = ref(null);
    const state = reactive({
      imgURL: window.imgURL,
      formVisible: false,
      formVisibleobject: false,
      setupVisible: false,
      tableParams: {
        careId: "",
        libraryId: props.form.libraryId,
      },
      tableCarParams: {
        libraryId: props.form.libraryId,
        // name: "string",
      },
      userFormData: {},
      status: 1,
      columns: [
        { type: "selection" },
        {
          label: "图片",
          slot: "imageUrl",
        },
        {
          label: "姓名",
          hidden: true,
          slot: "name",
          // prop: "name"
        },
        // {
        //   label: "性别",
        //   prop: "sexDict" // sex
        // },
        {
          label: "证件号码",
          prop: "cardNumber",
        },
        // {
        //   label: "民族",
        //   prop: "nationDict" // nation
        // },
        // {
        //   label: "居住地址",
        //   prop: "registerDetail"
        // },
        // {
        //   label: "电话",
        //   prop: "telphone"
        // },
        {
          type: "operate",
          label: "操作",
          width: "140px",
          operates: [
            { name: "编辑", emitKey: "edit" },
            { name: "布控", emitKey: "bk" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
      columnsCar: [
        { type: "selection" },
        {
          label: "车牌号",
          slot: "carNumber",
        },
        {
          label: "车身颜色",
          prop: "carColorDict",
        },

        {
          label: "车辆类型",
          prop: "carTypeDict",
        },

        {
          type: "operate",
          label: "操作",
          width: "140px",
          operates: [
            { name: "编辑", emitKey: "edit" },
            { name: "布控", emitKey: "bk" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
      tableData: [],
      tableSelection: [],
    });
    // 监听
    watch(
      () => state.formVisible,
      (v) => {}
    );

    const methods = {
      // 添加弹框
      addButton() {
        state.formVisible = true;
        state.status = 1;
      },
      selectButton() {
        state.formVisibleobject = true;
      },
      // 删除
      delUser() {
        ElMessageBox.confirm(
          `您确认要删除该${
            props.form.libraryFlag == "1" ? "人员" : "车辆"
          }吗？`,
          "删除",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(
          () => {
            const ids = state.tableSelection.map((item) => {
              if (props.form.libraryFlag == "1") {
                return item.faceId;
              } else {
                return item.carId;
              }
            });
            methods.deleteAxios(ids);
          },
          () => {}
        );
      },
      nameCLickDialog(row) {
        state.formVisible = true;
        state.status = 3;
        state.userFormData = row;
      },
      // 删除
      async deleteAxios(id) {
        let res;
        if (props.form.libraryFlag == "1") {
          res = await baseprisondelete(id);
        } else {
          const params = {
            ids: id,
          };
          console.log(params);
          res = await baseCarDetele(params);
        }
        if (res.code === 0) {
          ElMessage.success("删除成功");
          methods.refreshTable();
        }
      },
      // 点击table操作按钮
      handleClick(operate, row) {
        const { emitKey } = operate;
        if (emitKey === "del") {
          ElMessageBox.confirm(
            `您确认要删除该${
              props.form.libraryFlag == "1" ? "人员" : "车辆"
            }吗？`,
            "删除",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          ).then(
            () => {
              methods.deleteAxios([
                props.form.libraryFlag == "1" ? row.faceId : row.carId,
              ]);
            },
            () => {}
          );
        } else if (emitKey === "bk") {
          // 编辑
          ElMessageBox.confirm(
            `您确认要布控该${
              props.form.libraryFlag == "1"
                ? "人员"
                : "车牌为<" + row.carProvinceDict + row.carNumber + ">的车辆"
            }吗？`,
            "删除",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          ).then(
            () => {
              methods.disposition(row);
            },
            () => {}
          );
        } else if (emitKey === "edit") {
          // 编辑
          state.formVisible = true;
          state.status = 2;
          state.userFormData = row;
        }
      },

      // 当用户手动勾选数据行的 Checkbox 时触发的事件
      hzTableSelect(selection) {
        state.tableSelection = selection;
      },
      refreshTable() {
        tableRef.value && tableRef.value.refresh();
      },
      // 取消
      cancel() {
        state.formVisibleobject = false;
      },
      // 添加
      async tableSelectionObj(select) {
        const prisonIds = select.map((item) => {
          return item.prisonId;
        });
        const params = {
          prisonIds,
          libraryId: props.form.libraryId,
        };
        const res = await saveByPrison(params);
        if (res.code == 0) {
          ElMessage.success("添加成功");
          methods.refreshTable();
        }
        // tableRef.value.tableData = tableRef.value.tableData.concat(select);
        // methods.cancel();
      },
      // 布控
      async disposition(row) {
        let res;
        if (props.form.libraryFlag == 2) {
          const params = {
            number: row.carNumber,
            plate: row.carProvinceDict,
            plateColor: row.carCardColor,
            plateOwnershipCode: row.carProvince,
          };
          res = await dispositionCar(params);
        } else if (props.form.libraryFlag == 1) {
          const resBase64 = await url2ToBase({
            paths: [state.imgURL + row.fileUrl],
          });
          if (!resBase64.data[0]) {
            ElMessage.warning("无有效人员图片");
            return;
          }
          const params = {
            imgData: "data:image/jpeg;base64," + resBase64.data[0],
          };
          res = await dispositionFace(params);
        }
        if (res.code == 0) {
          ElMessage.success("布控成功");
        } else {
          ElMessage.error("操作失败");
        }
      },
    };
    watchEffect(() => {
      state.tableParams.careId = props.form.careId;
      // tableRef.value.tableData = [];
      // methods.refreshTable();
    });
    const setUpClick = () => {
      state.status = 1;
      state.setupVisible = true;
    };
    return {
      ...toRefs(state),
      ...methods,
      formRef,
      tableRef,
      basepeoplegetprison,
      baseCargetList,
      setUpClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.careStaffLibrary {
  width: 100%;
  img {
    width: 42%;
    height: 90px;
  }
  .tabs-card {
    width: 100%;
    .table-box {
      height: 100%;
      .table-row-name {
        cursor: pointer;
        color: #1887ff;
      }
    }
  }
}
</style>
